import React from 'react';
import { Chip } from '@mui/material';
import { ORIGINS } from './constants';

type TextureOriginProps = {
  origin: string[];
  setOrigin: (origin: string[]) => void;
};

export const TextureOrigin: React.FC<TextureOriginProps> = ({ origin, setOrigin }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '4px',
        marginBottom: '10px',
        gap: '8px',
      }}
    >
      <Chip
        label="Français"
        color={origin.includes('FRENCH') ? 'primary' : 'default'}
        onClick={() => {
          if (origin.includes('FRENCH')) {
            setOrigin(origin.filter((el) => el !== 'FRENCH'));
          } else {
            setOrigin([...origin, 'FRENCH']);
          }
        }}
      />
      <Chip
        label="Import"
        color={origin.includes('IMPORT') ? 'primary' : 'default'}
        onClick={() => {
          if (origin.includes('IMPORT')) {
            setOrigin(origin.filter((el) => el !== 'IMPORT'));
          } else {
            setOrigin([...origin, 'IMPORT']);
          }
        }}
      />
    </div>
  );
};
